import request from '@/router/axios'

const API = '/api/produce/transport-plan-progress'
const LEGACY_PLAN_API = '/api/produce/transport-plan/select/page'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) {
    return body.data
  }
  return body
}

export function fetchOverview(data) {
  return request({ url: `${API}/overview`, method: 'post', data }).then(unwrap)
}

export function fetchHeatmap(data) {
  return request({ url: `${API}/heatmap`, method: 'post', data }).then(unwrap)
}

export function fetchMonthTrend(data) {
  return request({ url: `${API}/month-trend`, method: 'post', data }).then(unwrap)
}

export function fetchRiskReasons(data) {
  return request({ url: `${API}/risk-reasons`, method: 'post', data }).then(unwrap)
}

export function fetchCustomerRank(data) {
  return request({ url: `${API}/customer-rank`, method: 'post', data }).then(unwrap)
}

export function fetchDetailPage(data) {
  return request({ url: `${API}/detail-page`, method: 'post', data }).then(unwrap)
}

export function fetchCustomerDetail(data) {
  return request({ url: `${API}/customer-detail`, method: 'post', data }).then(unwrap)
}

export function fetchOwnerOptions() {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get'
  }).then(unwrap)
}

export function fetchCargoOptions(keyword = '') {
  return request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params: { varName: keyword }
  }).then(unwrap)
}

export function getDetailList(data) {
  return request({ url: LEGACY_PLAN_API, method: 'post', data })
}
